import React, {useEffect, useState} from "react";
import TooltipTrigger from "../bootstrap/TooltipTrigger";
import {JSON_HEADERS} from "../../constants/constants";

export default function Like({item, itemUrl, itemLikeUrl, userSignedIn, currentUser, token, hoverBg, condenseOnMobile, gtmDataAttributes = {}, toggleRegistration, leadData={}}) {

    const [like, setLike] = useState(!!item.current_user_liked);
    const [likes, setLikes] = useState(item.likes);

    const onLike = async() => {
        if(userSignedIn) {
            await fetch(itemLikeUrl, {
                method: 'POST',
                headers: JSON_HEADERS,
                body: JSON.stringify({ authenticity_token: token })
            });
            setLikes(likes + (like ? -1 : 1)); // based on original like value
            setLike(!like);
        } else toggleRegistration(leadData);
    }

    return (
        <TooltipTrigger id={`like_${item.id}`} placement={'top'} content={ like ? 'Click to unlike' : 'Like this post'}>
            <a
                {...gtmDataAttributes}
                data-after-signin-redirect={itemUrl}
                data-external-only={1}
                className={`p-2 link-${ like ? 'success' : 'secondary'} font-14 hover-bg-${hoverBg}`}
                onClick={() => onLike() }>
                <i className={'fal me-2 fa-thumbs-up'}></i>
                <span className={`fw-bold ${condenseOnMobile && 'd-none d-sm-inline-block'}`}>Like ({likes})</span>
            </a>
        </TooltipTrigger>
    )
}